export default {

  //定义相关静态图片变量
  defaultAva: import.meta.env.VITE_FILE_URL + 'images/sysuser.png',  // 默认登录用户头像

  defaultImg: import.meta.env.VITE_FILE_URL + 'images/noimage.png',  // 无图片时默认图
  adminImage: import.meta.env.VITE_FILE_URL + 'images/adminLogo.png',  // 收起菜单显示的图标
  loginImage: import.meta.env.VITE_FILE_URL + 'images/loginLogo.png',  // 登录页面显示的图标

  loginBgSVG: import.meta.env.VITE_FILE_URL + 'svgs/saasBg.svg',  // 登录图标svg
  loginMainSVG: import.meta.env.VITE_FILE_URL + 'svgs/saasMain.svg',  // 登录图标svg

  errImgage401: import.meta.env.VITE_FILE_URL + 'error/401.png',
  errImgage403: import.meta.env.VITE_FILE_URL + 'error/403.png',
  errImgage404: import.meta.env.VITE_FILE_URL + 'error/404.png',

  errImgageCloud: import.meta.env.VITE_FILE_URL + 'error/cloud.png',
}